import { TAnswerState } from '../../../../containers/FormContainer/types/internal';
import { TPriceField } from '../../../../containers/FormContainer/types';

export const priceMapper = (answerState: TAnswerState) => {
  const value = answerState.value as TPriceField;

  return {
    [answerState.answerField]: {
      value: value.value,
      gte: value.gte,
      lte: value.lte,
      ...value.options?.reduce((acc, option) => ({ ...acc, [option]: true }), {}),
    },
  };
};
